module.exports = __webpack_public_path__ + "static/media/online-learning.a12d7fc7.png";